import React, { useState } from 'react'
import useSound from 'use-sound'
import { Avatar, Badge, Card, Dropdown, Menu, Space, Spin, Typography } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import styled, { createGlobalStyle } from 'styled-components'
import { useGetMyNotificationQuery, useGetMyNotificationSubScription } from 'graphQL/useGetMyNotification'
import { useHistory } from 'react-router'
import { MyNotificationAPIPayload } from 'graphQL/useGetMyNotification/interface'
import NotificationDropdownList from './NotificationDropdownList'
import { routePaths } from 'pages/routeConfig'
import notiSound from '../../assets/sound/notification.mp3'
const { Title, Link } = Typography

const NotificationDropdown: React.FC = () => {
  const history = useHistory()
  const [play] = useSound(notiSound)
  const [notificationList, setNotificationList] = useState<MyNotificationAPIPayload[]>()
  const [notificationCount, setNotificaitonCount] = useState<number | undefined>()

  const myNotificationRespQuery = useGetMyNotificationQuery({
    fetchPolicy: 'network-only',
    variables: {
      input: {
        pagination: {
          limit: 4,
          page: 1,
        },
      },
    },
    onCompleted(resp) {
      const data = resp.getMyNotification
      setNotificationList(data?.payload)
      setNotificaitonCount(data?.unread)
    },
  })
  useGetMyNotificationSubScription({
    fetchPolicy: 'network-only',
    variables: {
      input: {
        pagination: {
          limit: 4,
          page: 1,
        },
      },
    },
    onSubscriptionData(resp) {
      const data = resp.subscriptionData.data?.getMyNotification
      setNotificationList(data?.payload)
      setNotificaitonCount(data?.unread)
      play()
    },
  })

  return (
    <>
      <GlobalStyle />

      <Dropdown overlayClassName="user-dropdown-menu" overlay={renderMemu()} trigger={['click']}>
        <a href="#open-user-menu" className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
          <Space size={8}>
            <Badge count={notificationCount}>
              <Avatar
                style={notificationCount ? { backgroundColor: '#ffbf00' } : {}}
                shape="circle"
                icon={<BellOutlined />}
              />
            </Badge>
          </Space>
        </a>
      </Dropdown>
    </>
  )

  function renderMemu() {
    return myNotificationRespQuery.loading ? (
      <Menu selectable>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <Spin />
        </div>
      </Menu>
    ) : (
      <Card>
        <Title level={4}>การแจ้งเตือน</Title>
        <LinkStyle underline onClick={() => history.push(routePaths.notification)}>
          ดูทั้งหมด
        </LinkStyle>
        <NotificationDropdownList data={notificationList} />
      </Card>
    )
  }
}

export default NotificationDropdown

const GlobalStyle = createGlobalStyle`
  .user-dropdown-menu {
    top: 50px !important;
    > .ant-dropdown-menu {
      margin-top: 8px;
      padding: 10px
    }
    width: 300px;
    
  }
`
const LinkStyle = styled(Link)`
  display: flex;
  justify-content: end;
`
